/* Brandawi - برانداوي | Copyright © Brandawi. Product wishlist fallback handler */
(function () {
  var STORAGE_KEY = 'brandawiProductWishlist';
  var RECIPE_STORAGE_KEY = 'recipeWishlist';

  function safeParseArray(raw) {
    if (!raw) return [];

    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function normalizeProductItem(item) {
    if (item == null) return null;

    if (typeof item === 'string' || typeof item === 'number') {
      return {
        id: String(item),
        type: 'product'
      };
    }

    if (typeof item === 'object' && item.id != null) {
      return {
        id: String(item.id),
        url: item.url ? String(item.url) : '',
        title: item.title ? String(item.title) : '',
        img: item.img ? String(item.img) : '',
        type: 'product'
      };
    }

    return null;
  }

  function readWishlist() {
    var list = safeParseArray(localStorage.getItem(STORAGE_KEY))
      .concat(safeParseArray(localStorage.getItem(RECIPE_STORAGE_KEY)));
    var byId = {};

    list.map(normalizeProductItem).filter(Boolean).forEach(function (item) {
      var existing = byId[item.id];
      if (!existing) {
        byId[item.id] = item;
        return;
      }

      if (!existing.url && item.url) existing.url = item.url;
      if (!existing.title && item.title) existing.title = item.title;
      if (!existing.img && item.img) existing.img = item.img;
    });

    return Object.keys(byId).map(function (id) {
      return byId[id];
    });
  }

  function writeWishlist(list) {
    try {
      var payload = JSON.stringify(list);
      localStorage.setItem(STORAGE_KEY, payload);
      localStorage.setItem(RECIPE_STORAGE_KEY, payload);
    } catch (error) {
      // noop
    }
  }

  function isActive(productId) {
    return readWishlist().some(function (item) {
      return String(item.id) === String(productId);
    });
  }

  function setActiveState(button, active) {
    if (!button) return;

    button.classList.toggle('is-active', active);
    button.classList.toggle('active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function extractProductData(section, productId) {
    var title = section.dataset.productTitle || document.title || 'Product';
    var url = section.dataset.productUrl || window.location.pathname;
    var img = section.dataset.productImage || '';

    if (!img) {
      var imageElement = section.querySelector('.product__media img, .product__media-subitem img');
      if (imageElement && imageElement.src) {
        img = imageElement.src;
      }
    }

    return {
      id: String(productId),
      url: String(url),
      title: String(title),
      img: String(img || ''),
      type: 'product'
    };
  }

  function notifyChange() {
    document.dispatchEvent(
      new CustomEvent('brandawi:wishlist:changed', {
        detail: { key: STORAGE_KEY }
      })
    );
  }

  function toggleProduct(item, button) {
    var list = readWishlist();
    var index = list.findIndex(function (entry) {
      return String(entry.id) === String(item.id);
    });

    if (index > -1) {
      list.splice(index, 1);
      writeWishlist(list);
      setActiveState(button, false);
      notifyChange();
      return;
    }

    list.push(item);
    writeWishlist(list);
    setActiveState(button, true);
    notifyChange();
  }

  function resolveWishlistButton(section) {
    return section.querySelector(
      '.product-form .brandawi-product-wishlist-btn, ' +
      '.product-form [data-brandawi-wishlist-product-trigger], ' +
      '.product-form .nm-portal button:not(.nm-wishlist-open-list-button), ' +
      '.product-form .nm-portal a:not(.nm-wishlist-open-list-button), ' +
      '.product-form .nm-portal [class*=\"wishlist\"]:not(.nm-wishlist-open-list-button), ' +
      '.product-form .nm-portal [data-action*=\"wishlist\"]'
    );
  }

  function bindSection(section) {
    if (!section) return;

    var productId = section.dataset.productId;
    if (!productId) return;

    var candidate = resolveWishlistButton(section);
    if (!candidate) return;

    if (section.__brandawiWishlistButton !== candidate) {
      if (section.__brandawiWishlistButton && section.__brandawiWishlistHandler) {
        section.__brandawiWishlistButton.removeEventListener('click', section.__brandawiWishlistHandler);
      }

      section.__brandawiWishlistHandler = function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggleProduct(extractProductData(section, productId), candidate);
      };

      section.__brandawiWishlistButton = candidate;
      candidate.addEventListener('click', section.__brandawiWishlistHandler);
    }

    setActiveState(candidate, isActive(productId));
  }

  function observeSection(section) {
    bindSection(section);

    var observer = new MutationObserver(function () {
      bindSection(section);
    });

    observer.observe(section, {
      childList: true,
      subtree: true
    });
  }

  function syncAllSections() {
    document.querySelectorAll('.main-product-page').forEach(function (section) {
      bindSection(section);
    });
  }

  function init() {
    document.querySelectorAll('.main-product-page').forEach(observeSection);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('brandawi:wishlist:changed', syncAllSections);
})();
